import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, HelpCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

export const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-dark flex items-center justify-center px-4">
      <Card className="bg-light/5 border-gold/20 max-w-md w-full">
        <CardHeader className="text-center">
          <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-12 h-12 text-red-500" />
          </div>
          <CardTitle className="text-3xl font-playfair text-white">
            Paiement Annulé
          </CardTitle>
          <p className="text-gray-400 mt-2">
            Votre paiement n'a pas été effectué
          </p>
        </CardHeader>
        
        <CardContent>
          <div className="bg-white/5 rounded-sm p-4 border border-gold/20 mb-6">
            <p className="text-gray-300 text-sm">
              Vous avez annulé le processus de paiement. Aucun montant n'a été débité.
            </p>
          </div>

          <div className="space-y-3">
            <Button
              onClick={() => navigate('/services')}
              className="w-full bg-gold hover:bg-gold-light text-dark"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour aux services
            </Button>
            <Button
              onClick={() => navigate('/#contact')}
              variant="outline"
              className="w-full border-gold/30 text-gold hover:bg-gold/10"
            >
              <HelpCircle className="w-4 h-4 mr-2" />
              Besoin d'aide ?
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};